import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CertificateDownload from '../components/CertificateDownload';
import DocumentValidator from '../components/DocumentValidator';
import NameValidator from '../components/NameValidator';
import HtmlTooltip from '../components/ui/HtmlTooltip';
import InformationIcon from '../components/ui/InformationIcon';
import { border } from '../utils/theme.js';
import Box from '@mui/material/Box';

export default function CertificateValidations({
    onValidated,
    onValidationFailed,
    onValidationReset,
    certificate,
    validated,
    previewImg,
    name,
    styleColor,
    onExpiredToken,
}) {
    const { t } = useTranslation();
    return (
        <>
            <Box
                sx={{
                    ...border,
                    borderRadius: 4,
                    paddingX: 2,
                    paddingY: { xs: 1, md: 2 },
                }}
            >
                <Stack spacing={1}>
                    <Stack pt={0} justifyContent={'space-between'} direction={'row'}>
                        <Typography variant="subtitle1">
                            {t(`certificate.validate_certificate.${certificate.emissionType}`)}
                        </Typography>
                        <HtmlTooltip text={t('certificate.protect_information')}>
                            <InformationIcon white={false} />
                        </HtmlTooltip>
                    </Stack>

                    <Typography variant="body2" paddingBottom={1}>
                        {t('certificate.enter_last_name')}
                    </Typography>
                    <NameValidator
                        validated={validated}
                        styleColor={styleColor}
                        certificate={certificate}
                        onValidated={onValidated}
                        onValidationFailed={onValidationFailed}
                        onValidationReset={onValidationReset}
                        name={name}
                    />
                    <Typography variant="body2" py={1}>
                        {validated
                            ? t('certificate.ceritificate_is_validated')
                            : t('certificate.download_after_validated')}
                    </Typography>

                    <CertificateDownload
                        certificate={certificate}
                        img={previewImg}
                        disabled={!validated}
                        color={styleColor}
                        onExpiredToken={onExpiredToken}
                    />
                    {certificate.has2FValidation && (
                        <>
                            <br />
                            <DocumentValidator certificate={certificate} styleColor={styleColor} />
                        </>
                    )}
                </Stack>
            </Box>
        </>
    );
}
